export class StockRecipeBookDto {
  all: number = 0;
  none: number = 0;
  suggested: number = 0;
  approvedActive: number = 0;
  approvedInactive: number = 0;
  rejected: number = 0;
  archived: number = 0;
}
